import en from './en.json';
import zh from './zh.json';
import id from './id.json';
import th from './th.json';
import vi from './vi.json';

export default { en, zh, id, th, vi };
